import React, { Component } from 'react';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import { http } from '../helper';
import DataTable from 'react-data-table-component';
import { BaseUrl } from '../common/config';
import Sidebar from '../common/sidebar';
import Popup from '../common/popup';
import moment from "moment";



class Holiday extends Component {

    
    constructor(props) {
        super(props);
        this.state = {
            searchTextVal:"",
            holidaylist: [],
            templist :[],
            loading: true,
            popupView: "",
            visibleAlert:false,
            holidayvalue : '',
        };

        if(!sessionStorage.getItem("isLoggedIn")){
            window.location.href = '/';
        }
        
        if(JSON.parse(sessionStorage.getItem('authData')) != '' && !JSON.parse(sessionStorage.getItem('authData')).adminRole.permissions.includes('manage_settings'))
            {
              window.location.href = '/unauthorized';
            }
     }

    getHolidaylist() {

      var loginDetails = {};
         if (sessionStorage.getItem('authData')) {
            loginDetails = JSON.parse(sessionStorage.getItem('authData'));
         }


        let URL = BaseUrl + "admin/holidays";
        http.get(URL).then((response) => {
            const sortedData = response.data.data.sort((a, b) => new Date(b.holidayDate) - new Date(a.holidayDate));
            this.setState({ holidaylist: sortedData, loading: false, templist:sortedData});
        }).catch((err) => {
            console.log(err);
        })
    }

    viewHolidayDetails(holiday) {
        let popupResult = <Popup
            extClass="order-pop title-left pop-container-sm"
            headMoreTxt={
                <>
                    <div className="order-top">
                        <div className="head">
                            <h4>Holiday Details</h4>
                        </div>
                    </div>
                </>
            }
            bodyMoreTxt={
                <>
                    <div className="order-top">
                        
                        <div className="bottom vendor-details holidaydetails">
                            <p><span className="labeltxt">Title</span>: {holiday.holidayTitle}</p>
                            <p><span className="labeltxt">Date</span>: {moment(holiday.holidayDate).format('DD-MM-YYYY')}</p>
                            {/* <p><span className="labeltxt">Status</span> - {holiday.holidayStatus}</p> */}
                            
                        </div>
                    </div>
                </>
            }
            closebtn={<><span onClick={() => this.setState({ popupView: "" })} className='close'></span></>}

           
        />;

        this.setState({ popupView: popupResult });

    }

    

    deleteHoliday = (value) =>
    {
        this.setState({visibleAlert:true,holidayvalue:value});
        
    }

    deleteHolidayValue = ()=>
    {

         var loginDetails = {};
         if (sessionStorage.getItem('authData')) {
            loginDetails = JSON.parse(sessionStorage.getItem('authData'));
         }

        let URL = BaseUrl + `admin/holidays/${this.state.holidayvalue._id}`;  
        http.delete(URL).then(async (response) => {
         
            if(response.data.success === true){
                
                window.location.reload();
            }

        
        }).catch((err) => {
            console.log(err);
            
        })  
    }
    alertPopupclose = () =>
    {
        this.setState({visibleAlert:false,holidayvalue:''});
    }
    componentDidMount() {
        this.getHolidaylist();
    }

    addholiday = () =>
    {
        window.location.href = '/holiday/add/';
    }

    handleReset=()=>{
        this.setState({searchTextVal:'',holidaylist:this.state.templist});
     };

    handleChange = async(value) => {
        this.setState({searchTextVal:value});
        this.filterData(value);
      };
           

      filterData = async(value) => {

        let accoun = this.state.templist;
        
        const lowercasedValue = value.toLowerCase().trim();
        let result = [];
        if (lowercasedValue.length>0){
            accoun.map((item)=>{
            if(item.holidayTitle.toString().toLowerCase().includes(lowercasedValue))
            {
              result.push(item);
            }
          })
          this.setState({holidaylist:result});
        }else {
        this.setState({holidaylist:accoun});
      }
      };


    render() {

        const columns = [
            {
                name: "Title",
                selector: row => row.holidayTitle,
                sortable: true,
            },
            {
                name: "Date",
                selector: row => moment(row.holidayDate).format('DD-MM-YYYY'),
                sortable: true,
            },            
            {
                name: "Actions",
                selector: row => <div style={{display:"flex"}}>
                    <a className='button title-tooltip title-up' data-title='View Details' style={{color: "white"}} onClick={this.viewHolidayDetails.bind(this, row)}><i className="fa fa-eye" aria-hidden="true"></i></a>
                    <a className='button title-tooltip title-up' data-title='Delete' style={{color: "white"}} onClick={this.deleteHoliday.bind(this, row)}><i className="fa fa-trash" aria-hidden="true"></i></a>
                      
                  
                    </div>,
                sortable: false,
            }
        ];

        const customStyles = {
            rows: {
                style: {
                    minHeight: '25px',
                },
            },
            headCells: {
                style: {
                    padding: '8px', // override the cell padding for head cells
                    
                },
            },
            cells: {
                style: {
                    padding: '8px', // override the cell padding for data cells
                    
                },
            },
        };

        const paginationComponentOptions = {
            rowsPerPageText: '',
            rangeSeparatorText: '',
            selectAllRowsItem: true,
            selectAllRowsItemText: '',
            noRowsPerPage:'',
        };

        return (
            <>
                <div className="dashboard-block">

                    
                        <Sidebar />
                    
                    <div className="dash-left">
                        <Header />

                        <section className="cart-block">
                        <div className="container">
                            <h1 className="checkout-title">Holiday Settings</h1>  

                            <div className="right-table-outer-wrap">
                            <div className="table-filter search-orders">
                              <div className='table-search-reset'>
                                <div className="table-search">
                                    <input type="text" value={this.state.searchTextVal} onChange={e => this.handleChange(e.target.value)} className="form-control" placeholder="Search by Title" />
                                    
                                </div>
                                <button className='submitbtn button search-holi-btn' onClick={e => this.filterData(this.state.searchTextVal)}><i className="fa fa-search"></i></button>
                               
                                <button className='resetbtn' type='reset' onClick={this.handleReset}>Reset</button>
                              </div>
                             
                              <div className='add-holidaybtn'>
                                <button className='addbtn' onClick={this.addholiday}>Add</button>
                              </div>
                            </div>
                            
                            <div className="table_overflow">
                           
                                    <DataTable
                                        columns={columns}
                                        noDataComponent={<div className='no-records-found'>Sorry, no holiday list were matching your keyword, try a new search.</div>}
                                        data={this.state.holidaylist}
                                        customStyles={customStyles}
                                        pagination
                                        paginationPerPage={25}
                                        progressPending={this.state.loading}
                                        paginationRowsPerPageOptions={[25, 50, 75, 100]}
                                        paginationComponentOptions={paginationComponentOptions }
                                    />
                                    
                                    </div>
                                   
                    

                            </div>
                        </div>
                        </section>
                        <Footer />
                        
                    </div>
                </div>
                {this.state.popupView}
                {this.state.visibleAlert === true && 
                <div className='custom-alert-pop paylater-popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Alert</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>Are you sure you want to delete?</p>

                                <div className='alert-buttons'>

                                    <a onClick={this.deleteHolidayValue.bind(this)} className="popup-alert-btn button" >OK</a>
                                    <a onClick={this.alertPopupclose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </>
        );
    }
}

export default Holiday;